var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.recibo
    ? _c(
        "table",
        { staticClass: "table is-narrow is-fullwidth is-marginless" },
        [
          _c("tbody", [
            _c("tr", [
              _c("th", [_vm._v("Tipo de recibo")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.recibo.tipo_recibo.nombre))]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Fecha liquidación")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("moment")(
                      new Date(_vm.recibo.fecha),
                      "dddd, DD/MM/YYYY"
                    )
                  ) + " "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Fecha de ingreso")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(
                    _vm._f("moment")(
                      new Date(_vm.recibo.created_at),
                      "dddd, DD/MM/YYYY, HH:mm:ss"
                    )
                  ) + " "
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }